<template>
    <div class="app-sidebar">
         <div>
             <div style="display:flex; border: 1px solid #EAEAEA; border-radius:3px ">
    <input type="text" placeholder="Search here" style="flex:1;border: 1px solid transparent;padding: 0.375rem 0.75rem;" >
    <button type="submit" style="border: 1px solid transparent; background-color:transparent"> <i class="ti-search"></i></button>
         </div>

              <div class="my-5 pt-5 cat-style" >
                 <div class="categ">
                <h4 class="cat-topic">CATEGORIES</h4>
                <div v-if="contentLoaded">
                  <div v-for="(category, i) in  categoryData" :key="i">
                    <ul class="listing">
                      <div class="cat-det">
                        <li class>
                          <router-link
                            class="cat-det"
                            :to="'/category/'+ category.dash + '/' + category.mask"
                            exact
                          >{{category.name}}</router-link>
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
               
              </div>


              <div class="my-5 ">
                 <h4 class="cat-topic">POPULAR POST</h4>
                 <div class="popular_post">
                   <div>
                    <img src="../assets/img/blog.png" style="border-radius:5px;"  class="">
                   </div>
                   <div class="cat-det" style="padding-left:1rem" >
                        <span>Face cosmetic</span><br>
                        <span style="color:#888888">   <img src="../assets/img/user.png" height="13px" width="13px">  Admin</span><br>
                        <span style="color:#888888">  <img src="../assets/img/calender.png" height="13px" width="13px"> Dec 26, 2017</span>

                   </div>
                


                 </div>
                  <div class="popular_post">
                   <div>
                    <img src="../assets/img/blog.png" style="border-radius:5px;"  class="">
                   </div>
                   <div class="cat-det" style="padding-left:1rem" >
                        <span>Skin care</span><br>
                        <span style="color:#888888">  <img src="../assets/img/user.png" height="13px" width="13px">   Admin</span><br>
                        <span style="color:#888888">  <img src="../assets/img/calender.png" height="13px" width="13px"> Dec 26, 2017</span>

                   </div>
                


                 </div>
                  <div class="popular_post">
                   <div>
                    <img src="../assets/img/blog.png" style="border-radius:5px;"  class="">
                   </div>
                   <div class="cat-det" style="padding-left:1rem" >
                        <span>Face Makeup</span><br>
                        <span style="color:#888888">   <img src="../assets/img/user.png" height="13px" width="13px">  Admin</span><br>
                        <span style="color:#888888">  <img src="../assets/img/calender.png" height="13px" width="13px"> Dec 26, 2017</span>

                   </div>
                


                 </div>
             
               
                <div class="popular_post">
                   <div>
                    <img src="../assets/img/blog.png" style="border-radius:5px;" class="">
                   </div>
                   <div class="cat-det" style="padding-left:1rem" >
                        <span>Eye Makeup</span><br>
                        <span style="color:#888888">   <img src="../assets/img/user.png" height="13px" width="13px">  Admin</span><br>
                        <span style="color:#888888">  <img src="../assets/img/calender.png" height="13px" width="13px"> Dec 26, 2017</span>

                   </div>
                


                 </div>
               <div class="popular_post">
                   <div>
                    <img src="../assets/img/blog.png" style="border-radius:5px;" class="">
                   </div>
                   <div class="cat-det" style="padding-left:1rem" >
                        <span>Makeup Plalettes</span><br>
                        <span style="color:#888888">   <img src="../assets/img/user.png" height="13px" width="13px">  Admin</span><br>
                        <span style="color:#888888">  <img src="../assets/img/calender.png" height="13px" width="13px"> Dec 26, 2017</span>

                   </div>
                


                 </div>
             
              </div>

              </div>


    </div>
</template>

<script>
var blogImg = require("../assets/img/blog.png");
var adminImg = require("../assets/img/user.png");
var calenderImg = require("../assets/img/calender.png");
var chatImg = require("../assets/img/chat.png");
var eyeImg = require("../assets/img/eye.png");
import axios from "axios";
export default {
  name: "BlogSidebar",
  data() {
    return {
      categoryData: [],
       productCategories: [],
       aboutImg: aboutImg,
       blogImg:blogImg,
      adminImg:adminImg,
      chatImg:chatImg,
      eyeImg:eyeImg,

    };
  },
  methods: {
     fetchProductCategories() {
      axios
        .get(APIURL + "categories")
        .then(response => {
          this.productCategories = response.data;
          this.categoryContentLoaded = true;
          if (this.hasSubcategories) {
            this.subcategoryData = res.data.subcategories;
            //console.log(this.subcategoryData)
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    fetchCategories() {
      var self = this;
      $.getJSON(APIURL + "categories", function(data) {
        self.categoryData = data;
      });
    }
  },
  created(){
 this. fetchProductCategories();
  },
  mounted() {
   
    this.fetchCategories();
  }
};
</script>
